





































import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util'
import PageRequest from '@/store/entities/page-request'
import { Component } from 'vue-property-decorator'
import Ajax from '../../lib/ajax'
import Link from '@/store/entities/link'
import Draggable from 'vuedraggable'
import SelectCategory from '@/components/menu/select-category.vue'
import SelectPage from '@/components/menu/select-page.vue'
import PickUrl from '@/components/menu/pick-url.vue'
import Modules from '@/components/menu/modules.vue'
import { EventBus } from '@/lib/eventbus';
class  PageMediaRequest extends PageRequest{
    keyword:string;
    linkType:any;
}
@Component({
    components: {
        Draggable,
        SelectCategory,
        SelectPage,
        PickUrl,
        Modules
    }
})
export default class Links extends AbpBase {
    pagerequest:PageMediaRequest=new PageMediaRequest();
    intervalId:any=null;
    progressVal:number=0;
    progressVis:boolean=false;
    progressStatus:string="active"
    link:Link = new Link();
    editlink:Link = new Link();
    editIndex:number= -1;
    dragging:boolean= false;
    get menuList(){
        return [
            {
                "name":this.L("Category"),
            },
            {
                "name":this.L("Pages"),
            },
            {
                "name":this.L("Links"),
            }
        ]
    }
    get list(){
        return this.$store.state.links.list;
    }
    set list(items){
        this.$store.dispatch({
            type:'links/setOrder',
            data:items
        }).then( async ()  => {
            await this.getpage();
        });
    }
    get loading(){
        return this.$store.state.links.loading;
    }
    get pageSize(){
        return this.$store.state.links.pageSize;
    }
    get totalCount(){
        return this.$store.state.links.totalCount;
    }
    get currentPage(){
        return this.$store.state.links.currentPage;
    }
    pageChange(page:number){
        this.$store.commit('links/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('links/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){         
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        this.pagerequest.linkType = [0];

        let queryObject = {
            SkipCount: this.pagerequest.skipCount,
            MaxResultCount: this.pagerequest.maxResultCount
        };

        this.pagerequest.linkType.forEach((type, index) => {
            queryObject[`LinkType[${index}]`] = type; // Dynamically add keys
        });
        //filters            
        await this.$store.dispatch({
            type:'links/getAll',
            data:queryObject
        })
    }
    async deletelink(id){
        await this.$store.dispatch({
            type:'links/delete',
            data:{id:id}
        })
        await this.getpage();
    }
    async up(row,index){
        await this.$store.dispatch({
            type:'links/up',
            data:row
        }).then( async ()  => {
            await this.getpage();
        })   
    }
    async down(row,index){
        await this.$store.dispatch({
            type:'links/down',
            data:row
        }).then( async ()  => {
            await this.getpage();
        })   
    }
    async save(index){
        this.list[index].name = this.editlink.name;
        this.list[index].order =this.editlink.order;
        this.list[index].url = this.editlink.url;
        this.editIndex = -1;
        this.editlink.id = this.list[index].id;
        await this.$store.dispatch({
            type:'links/update',
            data: this.editlink
        })
    }
    edit(row,index){ 
        let edit = new Link();
        edit.name = row.name;
        edit.order = row.order;
        edit.url = row.url;
        this.editlink = edit;
        this.editIndex = index;
    }
    columns=[
        {            
            title:this.L('Name'),
            slot:'name',
            wdith:120
        },
        {
            title:this.L('Url'),
            slot:'url',
            wdith:80
        },
        {
            title:this.L('Order'),
            slot:'order',
            wdith:80
        },
        {
            title: this.L('Action'),
            slot: 'action',
            width: 160
        }
    ]
    async progress(){
        let result = await this.$store.dispatch({
            type: "mediamanager/progress",
        })
        this.progressVal = result;
    }     
    async search(){
        this.$store.commit('link/setCurrentPage',1);
        this.getpage();
    }
    async created(){
        this.getpage();
    }
    mounted(){
        EventBus.$on('createMenuLink', () => {
            this.getpage();
        });
    }
};
